
export const ErrorType = {
	BASE_MISSING_DETAILS: "BASE_MISSING_DETAILS",
	BASE_INVALID_AMOUNT: "BASE_INVALID_AMOUNT",
	CC_MISSING_CARD: "CC_MISSING_CARD",
	CC_INVALID_CARD: "CC_INVALID_CARD",
	PP_MISSING_ACCOUNT: "PP_MISSING_ACCOUNT",
	PP_AUTHORIZATION_FAILED: "PP_AUTHORIZATION_FAILED",
	GOOGLE_UCB_SELECTION: 'GOOGLE_UCB_SELECTION'
};

class ErrorCodeRegistry {
  static instance = new ErrorCodeRegistry();

  constructor() {
      if (ErrorCodeRegistry.instance) {
          return ErrorCodeRegistry.instance;
      }

      this.errorSchemas = new Map([
        [ErrorType.BASE_MISSING_DETAILS, { description: "Payment details are missing", fatal: true }],
        [ErrorType.BASE_INVALID_AMOUNT, { description: "Invalid payment amount", fatal: false }],
        [ErrorType.CC_MISSING_CARD, { description: "Card number is missing", fatal: true }],
        [ErrorType.CC_INVALID_CARD, { description: "Invalid card number", fatal: true }],
        [ErrorType.PP_MISSING_ACCOUNT, { description: "PayPal account is missing", fatal: false }],
        [ErrorType.PP_AUTHORIZATION_FAILED, { description: "PayPal authorization failed", fatal: true }],
        [ErrorType.GOOGLE_UCB_SELECTION, { description: "User selected UCB credit card payment or PayPal method", fatal: false }],
      ]);

      ErrorCodeRegistry.instance = this;
  }

  getSchemaForCode(code) {
      return this.errorSchemas.get(code) || null;
  }
}

const errorCodeRegistry = new ErrorCodeRegistry();
export { errorCodeRegistry };
